import { useEffect } from "react";

import { useSelector } from "react-redux";

import { proNavigator } from "single-spa/react-app/ProNavigator";

import { selectIsReportLoaded } from "../../store/selectors/reportSelectors";

export const useDownloadFromDigest = (onDownload: () => void) => {
    const { downloadPdf } = proNavigator.getParams();

    const isReportLoaded = useSelector(selectIsReportLoaded);

    useEffect(() => {
        if (isReportLoaded && Boolean(Number(downloadPdf))) {
            onDownload();
        }
    }, [isReportLoaded]);
};
